import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PopoverContext = /*#__PURE__*/createContext({
  use: 'default'
});
export const PopoverProvider = ({
  use,
  children
}) => {
  return /*#__PURE__*/_jsx(PopoverContext.Provider, {
    value: {
      use
    },
    children: children
  });
};

/**
 * Provides the context for the `Popover` component.
 * Note: The context is only available when the `Popover` component is rendered as an ancestor.
 * @returns PopoverContext - The context for the `Popover` component.
 * @returns PopoverContext.use - The `use` value.
 */
export const usePopoverContext = () => {
  const popoverContext = useContext(PopoverContext);
  return popoverContext;
};